// extracted by mini-css-extract-plugin
export default {"error":"ErrorHandling_error__0mE01","backdrop":"ErrorHandling_backdrop__Oxpfo","inner1":"ErrorHandling_inner1__dd1f+","inner2":"ErrorHandling_inner2__4H3cX"};